import { css } from "@emotion/core";
import { fonts, fontSizes, color, breakpoints } from "../../theme/Theme";

export const profileStyles = css({
  margin: "auto",
  fontSize: fontSizes.placeholder,
  fontFamily: fonts.regular,
  color: color.secondary,
  ".title": {
    fontFamily: fonts.bold,
    fontSize: fontSizes.heading
  },
  ".grid-container": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: "6rem",
    rowGap: "1rem"
  },
  [`@media screen and (max-width: ${breakpoints.sm})`]: {
    ".grid-container": {
      display: "grid",
      gridTemplateColumns: "1fr"
    }
  },
  img: {
    maxWidth: "10rem",
    maxHeight: "10rem"
  },
  ".float-right": {
    float: "right"
  },
  ".added-gstin-header": {
    fontSize: fontSizes.placeholder
  },
  ".ant-slider": {
    width: "2.18rem",
    margin: "0"
  },
  ".ant-upload": {
    fontSize: fontSizes.label,
    width: "100%"
  },
  ".upload-icon": {
    float: "right",
    cursor: "pointer"
  },
  ".ant-slider-step": {
    backgroundColor: color.placeholder,
    maxWidth: "2.18rem"
  }
});
